import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from "@/components/ui/card";
import { Loader2, Mail, ArrowLeft } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!email || email.indexOf("@") < 0) { setError("Email inválido"); return; }
    setLoading(true); setError("");
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.detail || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-gradient-to-br from-slate-50 to-slate-100">
      <Card className="w-full max-w-md" data-testid="forgot-password-page">
        <CardHeader>
          <CardTitle className="flex items-center gap-2"><Mail className="w-5 h-5" /> Recuperar contraseña</CardTitle>
          <CardDescription>Te mandamos un link a tu email para volver a entrar.</CardDescription>
        </CardHeader>
        <CardContent>
          {sent ? (
            <div className="space-y-4 text-center py-6">
              <div className="w-12 h-12 rounded-full bg-emerald-100 flex items-center justify-center mx-auto">
                <Mail className="w-6 h-6 text-emerald-600" />
              </div>
              <p className="text-sm text-slate-700">
                Si el email <b>{email}</b> está registrado, te llegará un mensaje con el link de recuperación.
                Tiene una validez de <b>1 hora</b>.
              </p>
              <Link to="/login" className="text-sm inline-flex items-center gap-1 text-slate-600 hover:underline">
                <ArrowLeft className="w-3 h-3" /> Volver a iniciar sesión
              </Link>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label>Email</Label>
                <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="tu@email.com" data-testid="forgot-email" />
              </div>
              {error && <p className="text-sm text-red-500">⚠️ {error}</p>}
              <Button type="submit" disabled={loading} className="w-full" data-testid="forgot-submit">
                {loading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : null}
                Enviar link
              </Button>
              <Link to="/login" className="text-sm text-center block text-slate-500 hover:underline">Volver al login</Link>
            </form>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
